import React from 'react'
import IQILogo from 'assets/images/iqi_logo_only.png'
import JuwaiLogo from 'assets/images/juwai_logo_only.png'

const InvalidEncodedContent = () => {
  return (
    <div style={{  
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center',
      flexDirection: 'column',
      height: '100vh',
      width: '100%'
    }}>
      <div style={{ display: 'flex' }}>
        <img src={ IQILogo } style={{ width: 150, objectFit: 'contain' }}/>
        <img src={ JuwaiLogo } style={{ width: 150, objectFit: 'contain' }}/>
      </div>
      <br/>
      <h4 className={ 'mt-5 text-center' }> 
        Please use a valid website link to access the content.
      </h4>
    </div>
  )
}

export default InvalidEncodedContent;